import React from 'react'
import cx from 'classnames'

import Box from 'components/layout/Box/Box'
import ToggleArrow from 'components/ui/ToggleArrow/ToggleArrow'

import s from './LayersToggleLink.scss'


const LayersToggleLink = ({ className, titleClassName, title, arrowPosition, arrowDirection, onClick }) => {
  const isReverse = arrowPosition === 'left'

  return (
    <div
      className={cx(s.link, className, {
        [s.reverse]: isReverse,
      })}
      onClick={onClick}
    >
      <Box
        className={titleClassName}
        pl={isReverse ? 'xs' : null}
        pr={isReverse ? null : 'xs'}
      >
        {title}
      </Box>
      <ToggleArrow
        direction={arrowDirection}
      />
    </div>
  )
}


export default LayersToggleLink
